import { useRef, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import SpinningLogoComponent from "../spinning-logo/spinning-logo.component"
import "./work-item.component.css"
import StrapiImageComponent from "../strapi-image/strapi-image.component"
import { daggerNavigate } from "../../utils/navigate.util"

const WorkItemComponent = (props) => {
  const { CaseStudy, AddSpinningLogo } = props
  const [isVisible, setIsVisible] = useState(false)
  const ref = useRef(null)

  const navigate = useNavigate()

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(el)
        }
      },
      { threshold: 0.15 },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const handleNav = () => {
    daggerNavigate(() => navigate(`/study/${CaseStudy.data?.attributes?.Slug}`))
  }

  return (
    <div ref={ref} className="dagger-single-work-item" onClick={handleNav}>
      {AddSpinningLogo && (
        <div className="dagger-single-work-item-logo">
          <SpinningLogoComponent />
        </div>
      )}
      <div
        className={`dagger-single-work-item-content ${isVisible ? "dagger-work-item-visible" : "dagger-work-item-hidden"}`}
      >
        <div className="dagger-single-work-item-image">
          <div className="dagger-item-hint">View Work</div>
          <StrapiImageComponent
            attributes={CaseStudy.data?.attributes?.HeroImage?.data?.attributes}
            sizes="(max-width: 860px) 100vw, 75vw"
          />
        </div>
        <h6>{CaseStudy.data?.attributes?.Client}</h6>
        <h5>{CaseStudy.data?.attributes?.HeroCaption}</h5>
      </div>
    </div>
  )
}

export default WorkItemComponent
